import * as React from "react";
import { Polygon } from "@react-google-maps/api";

import type { Zone } from "../../types";
import { getNetworkColor } from "../../utils/networkColor";

const ZonePolygon = React.memo(function ZonePolygon({
  zone,
  active,
  onClick,
}: {
  zone: Zone;
  active: boolean;
  onClick: (z: Zone, e: google.maps.MapMouseEvent) => void;
}) {
  const colorKey = String(zone.id).split("_")[0].trim();

  const color = React.useMemo(() => getNetworkColor(colorKey), [colorKey]);

  const options = React.useMemo<google.maps.PolygonOptions>(
    () => ({
      fillColor: color,
      fillOpacity: active ? 0.5 : 0.2,
      strokeColor: color,
      strokeWeight: active ? 4 : 2,
      zIndex: active ? 2 : 1,
      clickable: true,
    }),
    [active, color]
  );

  const handleClick = React.useCallback(
    (event: google.maps.MapMouseEvent) => onClick(zone, event),
    [onClick, zone]
  );

  return (
    <Polygon paths={zone.polygon} options={options} onClick={handleClick} />
  );
});

export default ZonePolygon;
